import { Navigate, Outlet } from 'react-router'

import { useSession } from '@/contexts/auth/session'

export function SessionAuthRouteGuard() {
  const {
    state: { isUserAuthenticated },
  } = useSession()

  if (!isUserAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
